"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingPriceWrapper$ = exports.ListingPriceWrapper$outboundSchema = exports.ListingPriceWrapper$inboundSchema = void 0;
exports.listingPriceWrapperToJSON = listingPriceWrapperToJSON;
exports.listingPriceWrapperFromJSON = listingPriceWrapperFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingprice_js_1 = require("./fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingprice.js");
const fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingpricebypropertytype_js_1 = require("./fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingpricebypropertytype.js");
/** @internal */
exports.ListingPriceWrapper$inboundSchema = z.object({
    national: fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingprice_js_1.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$inboundSchema,
    property_type: z.array(fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingpricebypropertytype_js_1.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "property_type": "propertyType",
    });
});
/** @internal */
exports.ListingPriceWrapper$outboundSchema = z.object({
    national: fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingprice_js_1.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$outboundSchema,
    propertyType: z.array(fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingpricebypropertytype_js_1.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ListingPriceWrapper$;
(function (ListingPriceWrapper$) {
    /** @deprecated use `ListingPriceWrapper$inboundSchema` instead. */
    ListingPriceWrapper$.inboundSchema = exports.ListingPriceWrapper$inboundSchema;
    /** @deprecated use `ListingPriceWrapper$outboundSchema` instead. */
    ListingPriceWrapper$.outboundSchema = exports.ListingPriceWrapper$outboundSchema;
})(ListingPriceWrapper$ || (exports.ListingPriceWrapper$ = ListingPriceWrapper$ = {}));
function listingPriceWrapperToJSON(listingPriceWrapper) {
    return JSON.stringify(exports.ListingPriceWrapper$outboundSchema.parse(listingPriceWrapper));
}
function listingPriceWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ListingPriceWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ListingPriceWrapper' from JSON`);
}
//# sourceMappingURL=listingpricewrapper.js.map